<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="ni ni-tv-2"
        main="Relatórios"
        sub="Analítico da Meta"
      />

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anosafra"
              label="Selecione o Ano Safra"
            />
          </div>
          <div class="col-md-4 col-sm-12" v-if="this.$currentUser().is_admin || this.$currentUser().is_manager">
            <label class="form-control-label">Tipo</label>
            <multiselect
              placeholder="Selecione o tipo"
              v-model="filter.goalType"
              :options="goalTypes"
              label="label"
              track-by="value"
              rules="required"
            />
          </div>
          <div class="col-6" v-if="jobAssociatedType">
            <label class="form-control-label"> {{ filter.goalType.label }}</label>
            <multiselect
              placeholder="Selecione o(s) Usuário(s)"
              v-model="filter.seed_manager"
              :options="jobAssociatedUsers"
              :loading="isLoadingSeedManagers"
              label="name"
              track-by="id"
              :limit="1"
              :limit-text="limitText"
              :multiple="true"
            />
          </div>

          <div class="col-md-4 col-sm-12" v-if="selectedGoalTypeValue == 'manager'">
            <label class="form-control-label">Gerente Comercial</label>
            <multiselect
              placeholder="Selecione o Gerente Comercial"
              v-model="filter.manager"
              :options="filteredManagers"
              label="name"
              track-by="id"
              @input="filterSalesmen"
              :disabled="!currentUser.is_admin"
              @search-change="initManagers"
            />
          </div>
          <div class="col-12 col-md-5" v-if="selectedGoalTypeValue == 'salesman'">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              placeholder="Selecione o tipo"
              v-model="filter.salesman"
              :loading="isLoadingSalesman"
              :options="filteredSalesmen"
              label="name"
              track-by="id"
              :disabled="!currentUser.is_admin && !currentUser.is_manager"
              @search-change="loadSalesmen"
            />
          </div>
          <div class="col-md-5 col-sm-12">
            <base-input
              label="Nome do Produto"
              v-model="filter.name"
              placeholder="Nome do Produto"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Marca</label>
            <multiselect
              v-model="filter.brand"
              :options="brands"
              :loading="!brands.length"
              placeholder="Selecione a marca"
              :show-no-options="false"
              label="name"
              track-by="id"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Grupo</label>
            <multiselect
              v-model="filter.group"
              :options="groups"
              :loading="!groups.length"
              placeholder="Selecione o grupo"
              :show-no-options="false"
              label="descricao"
              track-by="id"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Subgrupo</label>
            <multiselect
              v-model="filter.subgroup"
              :options="subgroups"
              :loading="!subgroups.length"
              placeholder="Selecione o subgrupo"
              :show-no-options="false"
              label="descricao"
              track-by="id"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Coluna</label>
            <multiselect
              placeholder="Tipo de Coluna"
              :options="tableColumn"
              v-model="filter.tableColumn"
              :multiple="true"
              :limit="1"
              :limit-text="(count) => ` + ${count}`"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2"  @click="exportToExcel">Gerar Excel</base-button>
          <base-button
            type="primary"
            class="ml-2 mt-2"
            @click="generateReport"
            v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Histórico - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.salesman && Object.keys(filter.salesman).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Usuário - {{ filter.salesman.name }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Volume de Vendas - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesman && Object.keys(filter.salesman).length"
        >
          Vendedor: {{ filter.salesman.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anosafra && Object.keys(filter.anosafra).length"
        >
          Ano Safra: {{ filter.anosafra.descricao }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.name">
          Nome do Produto: {{ filter.name }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.code">
          Código: {{ filter.code }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.brand">
          Marca: {{ filter.brand }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.group && Object.keys(filter.group).length"
        >
          Grupo: {{ filter.group.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.subgroup && Object.keys(filter.subgroup).length"
        >
          Subgrupo: {{ filter.subgroup.descricao }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <div
        class="group-block"
        v-for="(products, group, index) in grouped_products"
        :key="index"
      >
        <el-table
          class="table-responsive table-striped"
          height="650"
          min-width="500px"
          :header-row-class-name="rowClass"
          min-wid_typeth="500px"
          :data="products"
          show-summary
          :summary-method="getSummaries"
        >
         <el-table-column
            width="150"
            label="Nome"
            prop="description"
          />

          <el-table-column :label="group">
            <el-table-column
              v-if="filter.tableColumn.includes('Marca') || filter.tableColumn.includes('Todas')"
              min-width="150"
              label="Marca"
              prop="brand"
            />
            <el-table-column
              v-if="filter.tableColumn.includes('Meta KG/LT') || filter.tableColumn.includes('Todas')"
              min-width="150"
              label="Meta KG/LT"
              prop="goal_volume"
              v-slot="{ row }"
            >
            {{ row.goal_volume && formatNumber(row.goal_volume) }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Vol. Realizado') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Vol. Realizado"
              prop="completed_volume"
              v-slot="{ row }"
            >
            {{ row.completed_volume && formatNumber(row.completed_volume) }}
            </el-table-column>

            <el-table-column
              v-if="filter.tableColumn.includes('Meta (R$)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta (R$)"
              prop="currency_goal"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                row.currency_goal.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('R$ Realizado') || filter.tableColumn.includes('Todas')"
              width="150"
              label="R$ Realizado"
              prop="currency_completed"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                row.currency_completed.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizado (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizado (%)"
              prop="goal_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{ row.goal_percent.toFixed(2) }} %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Financeiro (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Financeiro (%)"
              prop="goal_value_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{row.goal_value_percent.toFixed(2)}} %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Vol. Meta Estratégico') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Vol. Meta Estratégico"
              prop="strategic_volume"
            />
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizado Estratégico (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizado Estratégico (%)"
              prop="strategic_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{ row.strategic_percent.toFixed(2)}}
              %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Estratégico (R$)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Estratégico (R$)"
              prop="strategic_value"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                (row.strategic_value || 0).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizado Estratégico Financeiro (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizado Estratégico Financeiro (%)"
              prop="currency_strategic_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{row.currency_strategic_percent.toFixed(2)}}
              %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Quantidade do Pedido Em Carteira') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Quantidade do Pedido Em Carteira"
              prop="qtd_wallet"
            />
            <el-table-column
              v-if="filter.tableColumn.includes('Pedido em Carteira R$') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Pedido em Carteira R$"
              prop="currency_wallet"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                row.currency_wallet.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizada Total (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizada Total (%)"
              prop="total_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{  row.total_percent.toFixed(2) }}
              %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizada Total Financeiro (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizada Total Financeiro (%)"
              prop="currency_total_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{ row.currency_total_percent.toFixed(2) }}
              %
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />
      </div>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import { Table, TableColumn, DatePicker } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        anosafra: "",
        code: "",
        name: "",
        brand: "",
        group: null,
        subgroup: null,
        goalType: "",
        manager: {},
        mkt_manager: {},
        coordinated: {},
        seed_coordinated: {},
        seed_manager: [],
        salesman: {},
        tableColumn: []
      },
      managers: [],
      coordinateds: [],
      seed_coordinateds: [],
      goalTypes: [],
      brands: [],
      groups: [],
      subgroups: [],
      anosafras: [],
      salesmen: [],
      grouped_products: {},
      lastEdition: new Date(),
      salesman_validation: true,
      isLoading: false,
      isLoadingSalesman: false,
      tableColumn: [
        'Marca', 'Meta KG/LT', 'Vol. Realizado', 'Meta (R$)', 'R$ Realizado', 'Meta Realizado (%)',
        'Meta Financeiro (%)', 'Vol. Meta Estratégico', 'Meta Realizado Estratégico (%)', 'Estratégico (R$)',
        'Meta Realizado Estratégico Financeiro (%)', 'Quantidade do Pedido Em Carteira', 'Pedido em Carteira R$',
        'Meta Realizada Total (%)', 'Meta Realizada Total Financeiro (%)', 'Todas'
      ],
      isLoadingDefaultColumns: false,
      defaultColumns: [],
      isLoadingSeedManagers: true,
      jobAssociatedUsers: []

    };
  },
  methods: {
    limitText(count) { 
      return `+ ${count}`;
    },
    formatNumber(number) {
      const formattedNumber = Number(number).toFixed(2);
      const trimmedNumber = parseFloat(formattedNumber).toString();
      return Math.round(trimmedNumber);
    },
    initGoalTypes() {
      if (this.$currentUser().is_admin || this.$currentUser().is_manager) {
        this.goalTypes = [
          { label: 'Vegetal', value: 'admin' },
          { label: 'Gerente de Negócios', value: 'mkt_manager' },
          { label: 'Gerente de Sementes hf', value: 'grocery_manager' },
          { label: 'Gerente de Sementes de cereais', value: 'grain_manager' },
          { label: 'Gerente de Nutrição', value: 'nutrition_manager' },
          { label: 'Gerente de Irrigação', value: 'irrigation_manager' },
          { label: 'Gerente Comercial', value: 'manager' },
          { label: 'Vendedor', value: 'salesman' }
        ]
      } else {
        this.goalTypes = { label: 'Vendedor', value: 'salesman' }
      }
    },
    async getJobAssociatedUsers(job_association_category = null) {
      this.isLoadingSeedManagers = true;
      try {
        const params = { unpaged: true, q: {} }

        if (this.filter.anosafra) params.q.anosafra_id = this.filter.anosafra.id;
        if (job_association_category) params.q.job_association_category = job_association_category;
        
        const response = await this.$http.secured.get("/api/v1/users/", { params: params })

        this.jobAssociatedUsers = response.data;

        if (this.$currentUser().is_admin) return;
        if (!this.jobAssociatedUsers.map(el => el.id).includes(this.$currentUser().id)) return;
        
        this.jobAssociatedUsers = this.jobAssociatedUsers.filter((user) => user.id == this.$currentUser().id)
      } catch(error) {
        this.setError(error, "Something went wrong");
      } finally {
        this.isLoadingSeedManagers = false;
      }
    },
    async initManagers(query) {
      try {
        const response = await this.$http.secured.get("/api/v1/users", {
          params: {
            q: {
              name: query,
              is_manager: true,
              anosafra_id: this.filter.anosafra ? this.filter.anosafra.id : null, status: this.active
            },
        }})
        this.managers = response.data.users
        this.filteredManagers = this.managers;
      } catch (error) {
        console.error("[AnalyticalGoal][initManagers]", error);
      }
    },
    async initCoordinated(query) {
      try {
        const response = await this.$http.secured.get("/api/v1/users", {
          params: {
            q: {
              name: query,
              is_coordinator: true,
              anosafra_id: this.filter.anosafra ? this.filter.anosafra.id : null, status: this.active
            },
          },
        })
        this.coordinateds = response.data.users
      } catch (error) {
        console.error("[AnalyticalGoal][initCoordinated]", error);
      }
    },
    async getDefaultErpTables() {
      this.isLoadingDefaultColumns = true;
      try {
        const response = await this.$http.secured.get("/api/v1/admin/settings")
        this.defaultColumns = response.data.analytical_goal_column_configurations.default_columns.value;
        this.markDefaultColumnAsSelected();
      } catch(error) {
        console.log(error)
      } finally {
        this.isLoadingDefaultColumns = false;
      }
    },
    userInfo(data) {
      var title = "";
      var name = "";

      if (data.manager && this.selectedGoalTypeValue == "manager") {
        title = "GESTOR";
      } else if (this.selectedGoalTypeValue != "admin") {
        title = "VENDEDOR";
      }

      if (data.user) name = data.user.name;

      return title ? `${title} - ${name}` : `${name}`;
    },
    filterSalesmen(manager) {
      this.filteredSalesmen = manager.salesmans;
    },
    filterCoodinated(manager) {
      this.filteredManagers = manager.mkt_managers;
    },
    filterManager(manager) {
      this.filteredManagers = manager.coordinateds;
    },
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    rowClass({ row, rowIndex }) {
      if (rowIndex == 0) return "title-row";

      return "thead-light";
    },
    async generateReport() {
      this.isLoading = true;
      try {
        if (this.currentUser.is_salesman && !this.currentUser.is_manager) this.filter.salesman = this.$currentUser();

        const params = {
          "filter[product_code]": this.filter.code ? this.filter.code : null,
          "filter[desc_psv]": this.filter.name ? this.filter.name : null,
          "filter[codi_grp]": this.filter.group
            ? this.filter.group.erp_codes
            : null,
          "filter[marc_pro]": this.filter.brand
            ? this.filter.brand.name
            : null,
          "filter[codi_sbg]": this.filter.subgroup
            ? this.filter.subgroup.erp_code
            : null,
          anosafra_id: this.filter.anosafra ? this.filter.anosafra.id : null,
          subgrupo_id: this.filter.subgroup ? this.filter.subgroup.id : null,
          grupo_id: this.filter.group ? this.filter.group.id : null,
          "products[code]": this.filter.code ? this.filter.code : null,
          name: this.filter.name ? this.filter.name : null,
          brand_id: this.filter.brand ? this.filter.brand.id : null,
          analytical_report: true
        }

        if (this.jobAssociatedType) {
          const paramsKey = this.filter.goalType.value == 'mkt_manager' ? "mkt_manager_id" : "seed_id"

          params[paramsKey] = this.filter.seed_manager.map(el => el.id)
        } else {
          if (this.filter.salesman) params.user_id   = this.filter.salesman.id;
          if (this.filter.manager) params.manager_id = this.filter.manager.id;
        }

        const response = await this.$http.secured.get("/api/v1/report/analytical_goals", {
          params: params
        })

        this.lastEdition = new Date();
        this.grouped_products = response.data;
      } catch (error) {
        console.error("[AnalyticalGoal][generateReport]", error);
      } finally {
        this.isLoading = false;
      }
    },
    async initGroups() {
      try {
        const response = await this.$http.secured.get("/api/v1/grupos")
        this.groups = response.data;
      } catch (error) {
        console.error("[AnalyticalGoal][initGroups]", error);
      }
    },
    async initSubgroups() {
      try {
        const response = await this.$http.secured.get("/api/v1/subgrupos")
        this. subgroups = response.data;
      } catch (error) {
        console.error("[AnalyticalGoal][initSubgroups]", error);
      }
    },
    async loadSalesmen(query = null) {
      this.isLoadingSalesman = true;
      try {
        var data = {
          per_page: 10,
          q: { is_salesman: true , status: this.active },
        };

        if (this.filter.manager && this.filter.manager.id)
          data.q["manager_id"] = this.filter.manager.id;
        if (this.filter.manager && this.filter.manager.coordinated_id)
          data.q["manager_id"] = this.filter.manager.coordinated_id;
        if (this.filter.anosafra && this.filter.anosafra.id)
          data.q["anosafra_id"] = this.filter.anosafra.id;
        if (query) data.q.name = query;

        const response = await this.$http.secured.get("/api/v1/users", { params: data })
        this.salesmen = response.data.users || [];
        this.filteredSalesmen = this.salesmen;
      } catch (error) {
        console.error("[AnalyticalGoal][loadSalesmen]", error);
      } finally {
        this.isLoadingSalesman = false;
      }
    },
    async initData() {
      try {
        const response = await this.$http.secured.get("/api/v1/brands", {
          params: { name_only: true }
        })
        this.brands = response.data;
      } catch (error) {
        console.error("[AnalyticalGoal][initData]", error);
      }
    },
    salesQuantity(product) {
      if (product.sales_quantity) return product.sales_quantity.toFixed(2);
    },
    checkValidation() {
      if (
        !this.filter.salesman ||
        typeof this.filter.salesman == "undefined" ||
        this.filter.salesman == ""
      ) {
        this.salesman_validation = false;
        return false;
      }

      this.salesman_validation = true;
      return true;
    },
    getSummaries(param) {
      var { columns, data } = param;
      var sums = [];

      // Calcs
      for (const index in columns) {
        if (index == 0) {
          sums[index] = "TOTAL";
          continue;
        }

        var values = data.map((item) => Number(item[columns[index].property]));

        if (values.every((value) => isNaN(value))) {
          sums[index] = " ";
          continue;
        }

        if (index == 7) {
          if (sums[6] == 0 || sums[5] == 0){
            sums[index] = 0;
          } else {
            sums[index] = (100 * sums[6]) / sums[5];
          }
          continue;
        }

        if (index == 6) {
          if (sums[5] == 0 || sums[4] == 0){
            sums[index] = 0;
          } else {
            sums[index] = (100 * sums[5]) / sums[4];
          }
          continue;
        }

        if (index == 5) {
          if (sums[4] == 0 || sums[3] == 0){
            sums[index] = 0;
          } else {
            sums[index] = (100 * sums[4]) / sums[3];
          }
          continue;
        }

        sums[index] = values.reduce(
          (prev, curr) => (Number(curr) || 0) + prev,
          0
        );
      }

      // Formating results
      for (const index in columns) {
        if (columns[index].label.indexOf("R$") >= 0) {
          sums[index] = sums[index].toLocaleString("pt-BR", {
            style: "currency",
            currency: "brl",
          });
          continue;
        }
        if (
          columns[index].label.indexOf("%") >= 0 &&
          columns[index].label.toUpperCase().indexOf("META") >= 0
        ) {
          sums[index] = sums[index] ? sums[index].toFixed(2) + "%" : 0 + "%";
          continue;
        }

        sums[index] = " "; //sums[index].toFixed(2)
      }

      return sums;
    },
    clearFilters() {
      this.filter.goalType = null,
      this.filter.seed_manager = [],
      this.filter.manager = null,
      this.filter.salesman = null,
      this.filter.name = "",
      this.filter.brand = null,
      this.filter.group = null,
      this.filter.subgroup = "",
      this.filter.tableColumn = []
    },
    markDefaultColumnAsSelected() {
      if ((!this.defaultColumns || !this.defaultColumns.length) || !this.tableColumn.length) return;

      this.filter.tableColumn =  this.tableColumn.filter(column => this.defaultColumns.includes(column));
    },
  },
  mounted() {
    this.initGoalTypes();
    this.currentUser = this.$currentUser();
    this.getDefaultErpTables();
    this.initData();
    this.initGroups();
    this.initSubgroups();

    this.filter.tableColumn.push(this.tableColumn[15]);

    if (this.currentUser.is_manager) {
      this.filter.manager = this.$currentUser();
    } else if (this.currentUser.is_salesman) {
      this.filter.salesman = this.$currentUser();
    }
  },
  watch: {
    "filter.anosafra": function () {
       if(this.$can('index', 'user')){
        this.loadSalesmen();
        this.initManagers("");
        this.initCoordinated("");
      }
    },
    "filter.manager": function () {
       if(this.$can('index', 'user')){
        this.loadSalesmen("");
      }
    },
    "filter.goalType": function (goalType) {
      if (this.currentUser.is_admin) this.filter.manager = null;
      this.filter.salesman = [];

      if (this.jobAssociatedType) {
        this.getJobAssociatedUsers(goalType.value);
        return
      }
    },
  },
  computed: {
    jobAssociatedType() {
      return ['grocery_manager', 'irrigation_manager', 'grain_manager', 'nutrition_manager', 'mkt_manager'].includes(this.filter.goalType.value)
    },
    selectedGoalTypeValue() {
      if (!this.filter.goalType) return null;

      return this.filter.goalType.value;
    },
    setting_image() {
      return this.$store.state.imageSettings || {}
    },
    isSeedDerivedManager() {
      if (!this.filter.goalType) return false;

      return ['grocery', 'irrigation', 'grain', 'nutrition'].includes(this.filter.goalType.value)
    },
  }
};
</script>
<style lang="scss">
@media print {
  table {
    div.cell {
      font-size: 30%;
    }
  }

  th {
    min-width: 50%;
    width: 50%;
    max-width: 50%;
  }
  td {
    min-width: 50%;
    width: 50%;
    max-width: 50%;
  }

  @page {
    size: landscape;
  }
}
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}

.title-row {
  padding: 0;
  .cell {
    font-size: 150%;
    font-weight: bold;
  }
}
</style>
